import { Injectable } from '@angular/core';
import {
  PurchasePlanPermissions,
  ResponsePermissions,
} from '@aptitude/shared';
import {
  ResponseActions,
  ResponseDenialReasons,
} from '@aptitude/shared';
import { PermissionContext } from '@aptitude/shared';

@Injectable({
  providedIn: 'root',
})
export class LegacyRfpPermissionsService {
  private responsePermissions: ResponsePermissions = new ResponsePermissions(
    PermissionContext.SELLER_RFP_RESPONSE,
  );

  setPermissions(permissions: any) {
    this.responsePermissions.setPermissions(permissions);
  }

  canSubmitOffer(): boolean | undefined {
    return this.responsePermissions.canSubmitOffer();
  }

  getDenialReason(actionName: ResponseActions): ResponseDenialReasons | null {
    return this.responsePermissions.getDenialReason(actionName);
  }

  canRetractResponse() {
    return this.responsePermissions.canRetractResponse();
  }

  getPurchasePlanningPermissions(permissions: any): PurchasePlanPermissions {
    const purchasePlanning = new PurchasePlanPermissions(
      PermissionContext.PURCHASE_PLANNING,
    );
    purchasePlanning.setPermissions(permissions);
    return purchasePlanning;
  }
}
